import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import {Screen, Button} from '../components';
import {setUser} from '../actions';
import {__, formatAmount, formatDate, getCurrency, request} from '../functions';
import '../assets/styles/ai-chatbot-thread.css';
import {Chip, IconButton, Tooltip} from "@mui/material";
import AddIcon from "@mui/icons-material/AddCircle";

/**
 * AI chatbot thread.
 */
class AiChatbotThreadScreen extends Screen {
    title = __('AI chatbot - konverzácia');

    state = {
        data: {},
    };

    async componentDidMount() {
        if (super.componentDidMount()) {
            const { params, setUser } = this.props;

            request(`/ai-chatbot-threads/view/${params.id}`).then(response => {
                const { status, data, sync } = response.data;

                if (status === 'error') {
                    window.location = '/ai-chatbot/messages';
                    return;
                }

                setUser(sync.user);

                this.setState({ data });
            });
        }

        return true;
    }

    render() {
        const { data } = this.state;

        if (_.isEmpty(data)) {
            // Data nie su nacitane
            return this.renderLoading();
        }

        if (!this.hasPermission('aiaddons')) {
            // Nema pravo
            return null;
        }

        const email = _.has(data.thread, 'email') ? data.thread.email : '';
        const name = _.has(data.thread, 'name') ? data.thread.name : '';
        const ip = _.has(data.thread, 'ip') ? data.thread.ip : '';

        return (
            <div className="ai-chatbot-thread">
                <div className="ai-chatbot-thread__header">
                    <div className="ai-chatbot-thread__header__left">
                        <div className="ai-chatbot-thread__header__left__title">{__('AI chatbot - konverzácia')}</div>
                    </div>
                    <div className="ai-chatbot-thread__header__right">
                        <Button
                            onClick={() => window.location = '/ai-chatbot/messages'}
                            color="shadow"
                        >{__('Naspäť')}</Button>
                    </div>
                </div>
                <div className="ai-chatbot-thread__user">
                    {email !== '' ? <Chip label={`${__('Email')}: ${email}`} style={{ marginRight: '2px', marginBottom: '2px' }} /> : null}
                    {name !== '' ? <Chip label={`${__('Meno')}: ${name}`} style={{ marginRight: '2px', marginBottom: '2px' }} /> : null}
                    {ip !== '' ? <Chip label={`${__('IP')}: ${ip}`} style={{ marginRight: '2px', marginBottom: '2px' }} /> : null}
                </div>
                <div className="ai-chatbot-thread__content">
                    {_.map(data.messages, message => {
                        let answer = '';
                        let price = 0;

                        if (message.status === 'processed' || message.status === 'error') {
                            answer = message.status === 'error' ? `Error: ${message.error}` : message.answer;

                            if (message.status === 'processed' && _.has(data.transactions, message.ai_transaction_id)) {
                                price = data.transactions[message.ai_transaction_id];
                            }
                        }

                        return (
                            <>
                                <div className="ai-chatbot-thread__content__message message-user" key={message.id}>
                                    <div className="ai-chatbot-thread__content__message__main">
                                        <div className="ai-chatbot-thread__content__message__main__content">{message.message}</div>
                                        <div className="ai-chatbot-thread__content__message__main__buttons">
                                            <Tooltip title={__('Vytvoriť otázku')}>
                                                <IconButton
                                                    onClick={() => this.redirect(`/ai-chatbot/questions/${message.id}`)}
                                                >
                                                    <AddIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <div className="ai-chatbot-thread__content__message__time">{formatDate(message.created, 'hh:ii')}</div>
                                </div>
                                {answer !== '' ? <div className="ai-chatbot-thread__content__message message-assistant" key={`${message.id}-answer`}>
                                    <div className="ai-chatbot-thread__content__message__main">
                                        <div className="ai-chatbot-thread__content__message__main__content" dangerouslySetInnerHTML={{ __html: answer }} />
                                    </div>
                                    <div className="ai-chatbot-thread__content__message__time">{formatDate(message.modified, 'hh:ii')}, {__('Cena:')} {formatAmount(price, 'EUR', 8)}</div>
                                </div> : null}
                            </>
                        );
                    })}
                </div>
                {this.renderSnackbar()}
            </div>
        );
    }
}

const stateToProps = ({ user }) => ({ user });

export default withCookies(connect(stateToProps, {
    setUser,
})(AiChatbotThreadScreen));
